// Lightweight Imei service shim to avoid ReferenceError and provide persistence for StoreDB + device IMEI.
// The device IMEI is the value the backend expects in the `pc` query param on the Kazang payment endpoints
// (see OnlineSalesServer /api/payments/kazang/{storeDB}?pc=...). Caching it under the legacy '_capuid' key
// keeps every existing reader (kazang_module, accounts, stock, cashup, float) working unchanged.
const STORE_DB_KEY = 'kazang_store_db';
const DEVICE_IMEI_KEY = '_capuid'; // legacy key — every other module already reads from this

export const Imeis = {
  // Persist the Kazang StoreDB identifier for the device
  saveStoreDB(storeDB) {
    try {
      const value = storeDB ?? 'none';
      localStorage.setItem(STORE_DB_KEY, value);
    } catch (e) {
      // ignore storage errors
    }
  },

  // Retrieve the Kazang StoreDB identifier
  async getStoreDB() {
    try {
      const value = localStorage.getItem(STORE_DB_KEY);
      return value || 'none';
    } catch (e) {
      return 'none';
    }
  },

  // Persist the device IMEI under the legacy '_capuid' slot. Called once on login.
  // Fix for TD-XXX: previously never set, causing PC IS NULL on every Kazang payment INSERT
  // (Field 'PC' doesn't have a default value → 500 from the backend).
  saveDeviceImei(imei) {
    try {
      const value = imei ?? 'unknown';
      localStorage.setItem(DEVICE_IMEI_KEY, value);
    } catch (e) {
      // ignore storage errors
    }
  },

  // Retrieve the cached device IMEI. Returns 'unknown' (not null) so the `pc=` query param is never empty
  // — empty/missing `pc` causes the backend INSERT to fail on the NOT NULL PC column.
  async getDeviceImei() {
    try {
      const value = localStorage.getItem(DEVICE_IMEI_KEY);
      return value || 'unknown';
    } catch (e) {
      return 'unknown';
    }
  }
};
